var map = {
	"./adjust_on.png": 527,
	"./book_on.png": 529,
	"./cancelUpload_on.png": 534,
	"./change_class_name_on.png": 536,
	"./check_on.png": 43,
	"./delete_on.png": 538,
	"./download_on.png": 541,
	"./excel_on.png": 543,
	"./icon_quiz_on.png": 574,
	"./icon_read_on.png": 576,
	"./icon_text_on.png": 581,
	"./icon_video_on.png": 584,
	"./lesson_score_on.png": 585,
	"./more_dots_on.png": 589,
	"./more_info_on.png": 591,
	"./play_sound_on.png": 593,
	"./record_on.png": 595,
	"./setting_on.png": 597,
	"./share_on.png": 599,
	"./single_add_on.png": 601,
	"./student_download_on.png": 604,
	"./test_on.png": 607,
	"./text_ch_on.png": 609,
	"./text_dictionary_on.png": 611,
	"./text_jp_on.png": 613,
	"./text_key_on.png": 615,
	"./upload_on.png": 616
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 756;



//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon ^\.\/.*_on\.png$
// module id = 756
// module chunks = 1